import axios from 'axios'

import { API_BASE_URL, api } from './client'

export interface MintTraceCodeRequest {
    origin_type: string
    origin_id: string
}

export interface MintTraceCodeResponse {
    short_code: string
}

export interface PublicTraceArea {
    name: string
    acreage?: number
}

export interface PublicTraceGrower {
    name: string
    areas?: PublicTraceArea[]
}

export interface PublicTraceWeighing {
    weigh_date: string
    quantity: number
    tea_type?: string
}

export interface PublicTraceCareLogParcel {
    name: string
}

export interface PublicTraceCareLog {
    activity_type: string
    log_date: string
    parcels?: PublicTraceCareLogParcel[]
    quantity: number
    quarantine_note?: string | null
    fertilizers?: string[]
    pesticides?: string[]
}

export interface PublicTraceClassification {
    name: string
    code?: string | null
    weight: number
}

export interface PublicTracePackage {
    package_date: string
    weight: number
    is_approved?: boolean | null
}

export interface PublicTraceAroma {
    sampling_date: string
    code?: string | null
    weight: number
}

export interface PublicTraceTeaLot {
    lot_date: string
    quantity: number
    status?: string | null
}

export interface PublicTraceResult {
    origin_type: string
    tea_lot?: PublicTraceTeaLot
    grower?: PublicTraceGrower
    weighing?: PublicTraceWeighing
    care_logs?: PublicTraceCareLog[]
    classifications?: PublicTraceClassification[]
    packages?: PublicTracePackage[]
    aromas?: PublicTraceAroma[]
    external_ref?: string | null
}

export interface ResolveTraceCodeResult {
    origin_type: string
    origin_id: string
    is_active: boolean
}

export const traceCodesApi = {
    mint: (data: MintTraceCodeRequest) =>
        api.post<MintTraceCodeResponse>('/trace-codes', data),

    // Phase 5 — auth resolver (kho hàng bán). Khác với fetchPublicTrace ở chỗ
    // chỉ trả mapping origin → entity, để FE tự navigate đến trang chi tiết
    // trong hệ thống quản lý (vd /warehouse-sales/lots/{id}).
    resolve: (code: string) =>
        api.get<ResolveTraceCodeResult>(`/trace-codes/${code}`),
}

// Public endpoint — no auth cookie needed. Uses plain axios (not the api client)
// so the interceptors that redirect to /login on 401 are bypassed.
export async function fetchPublicTrace(
    code: string,
): Promise<PublicTraceResult | null> {
    try {
        const res = await axios.get<{
            success: boolean
            data?: PublicTraceResult
        }>(`${API_BASE_URL}/public/trace/${code}`)
        return res.data?.data ?? null
    } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
            return null
        }
        throw err
    }
}
